import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  SkyCoachContext,
  SkyCoachState,
  SkyCoachStateService,
} from '../service/sky/sky-coach-state.service';
import { SkyCharacterComponent } from './sky-character.component';

@Component({
  selector: 'app-sky-transition',
  standalone: true,
  imports: [CommonModule, SkyCharacterComponent],
  templateUrl: './sky-transition.component.html',
  styleUrl: './sky-transition.component.css',
})
export class SkyTransitionComponent implements OnInit, OnChanges, OnDestroy {
  @Input({ required: true }) context!: SkyCoachContext;
  @Input() eyebrow = 'Sky';
  @Output() closed = new EventEmitter<void>();

  protected state: SkyCoachState = { pose: 'welcome', message: '' };

  private closeTimer?: ReturnType<typeof setTimeout>;
  private closedOnce = false;

  constructor(
    private skyCoachState: SkyCoachStateService,
    private ngZone: NgZone,
  ) {}

  ngOnInit(): void {
    this.resolveState();
    // Safety net only; normal close happens when the situation clip ends.
    this.closeTimer = setTimeout(() => this.close(), 12_000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['context']) {
      this.resolveState();
    }
  }

  ngOnDestroy(): void {
    this.clearCloseTimer();
  }

  protected onSituationComplete(): void {
    this.clearCloseTimer();
    // Hold on the last frame, then dismiss automatically.
    this.closeTimer = setTimeout(() => this.close(), 1_850);
  }

  protected close(): void {
    if (this.closedOnce) {
      return;
    }
    this.closedOnce = true;
    this.clearCloseTimer();
    this.ngZone.run(() => this.closed.emit());
  }

  private resolveState(): void {
    this.state = this.skyCoachState.resolve(this.context ?? {});
    // Consume the situation slot so the inline results panel does not replay it.
    this.skyCoachState.shouldPlaySituation(this.context ?? {}, this.state);
  }

  private clearCloseTimer(): void {
    if (this.closeTimer != null) {
      clearTimeout(this.closeTimer);
      this.closeTimer = undefined;
    }
  }
}
